import React from "react";
import { useHeaderStyles } from "./style";
import { Box, Typography } from "@mui/material";
import PracticeIcon from "@mui/icons-material/School"; // Using an educational icon as a placeholder

const Title = () => {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {/* <PracticeIcon sx={{ color: "#000000", marginRight: 1 }} />{" "} */}
      {/* Logo Icon */}
      <Typography
        variant="h6"
        component="h1"
        sx={{
          fontWeight: "bold",
          color: "black",
          fontSize: "2.3rem",
          marginLeft: "10%",
        }}
      >
        tnikola
      </Typography>
    </Box>
  );
};

export default Title;
